import * as xlsx from 'xlsx';
import { IControl, IDomain, documentTableItem, sentenceItem } from '../models/interfaces';
import axios from 'axios';

const getSentenceForDoc = async (
  documentId: string,
  auth: any, 
) => {
  try {
    const sen = await axios.get(
      `${process.env.REACT_APP_API}/sentences/${documentId}`,
      auth
    );
    return sen.data;
  } catch (e) {
    return e;
  }
};
export const createMultiDocSheet = async (
  documents: documentTableItem[],
  domains: IDomain[],
  controls: IControl[],
  auth: any
) => {
  console.log(documents)
  const dataToExport = [];
  const allWorksheets = [];
let workbook = xlsx.utils.book_new();
let masterLineNo = 0;
  for (const doc of documents) {
    const sheetData = [];
    const docSentences: sentenceItem[] = await getSentenceForDoc(doc._id, auth);
    for (const sentence of docSentences) {
      if(sentence.predicted_label_domain && sentence.predicted_label_control) {
        masterLineNo ++
        const [domainToUse] = domains.filter(
          (ele) => ele.domainName.trim() === sentence.predicted_label_domain.trim()
        );
        
        const [controlToUse] = controls.filter(
          (ele) => ele.controlName.trim() === sentence.predicted_label_control.trim()
        );
        if(!controlToUse || !domainToUse) {
          console.log(sentence);
        }
        const tempObject = {
          'Main Index': sentence.sentenceIndex,
          'Document Name': doc.documentFileName,
          Text: sentence.text,
          Notes: sentence.notes,
          'Language Prediction': sentence.predicted_label_language,
          'Language Prediction Score': sentence.confidence_score_language,
          'Topic Prediction': sentence.predicted_label_domain,
          'Topic Predicction Score': sentence.confidence_score_domain,
          'Sub Topic Prediction': sentence.predicted_label_control,
          'Sub Topic Prediction Score': sentence.confidence_score_control,
          'Topic Name': domainToUse.domainName,
          'Topic Description': domainToUse.domainDescription,
          'Sub Topic Name': controlToUse ? controlToUse.controlName : '',
          'Subtopic Description': controlToUse
            ? controlToUse.controlDescription
            : '',
          Department: controlToUse ? controlToUse.controlDepartment : '',
          Owner: controlToUse ? controlToUse.controlOwners : '',
          Status: controlToUse ? controlToUse.controlStatus : '',
          type: sentence.type ? sentence.type : 'Null',
          burden: sentence.burden ? sentence.burden : '',
          parameters: sentence.parameters ?? false,
          parameter_arguments: sentence.parameter_arguments
            ? `${sentence.parameter_arguments.join(' ')}`
            : '',
          location: sentence.location ?? false,
          locations:
            sentence.locations.length > 0 ? sentence.locations.join(' ') : '',
          people_org: sentence.people_org ?? false,
          people_orgs:
            sentence.people_orgs.length > 0
              ? sentence.people_orgs.join(' ')
              : '',
          Time_Information: sentence.Time_Information ?? false,
          Time_Entities:
            (sentence.Time_Entities
               && sentence.Time_Entities.length > 0)
              ? sentence.Time_Entities.join(' ')
              : '',
          Quantity_Information: sentence.Quantity_Information ?? false,
          Financial_Information: sentence.Financial_Information ?? false,
          Financial_Amounts:
            sentence.Financial_Amounts.length > 0
              ? sentence.Financial_Amounts.join(' ')
              : '',
          Dates: sentence.Dates.length > 0 ? sentence.Dates.join(' ') : '',
          redlined: sentence.redlined ?? '',
          kbSentences: "",
        };
   
        sheetData.push({
         ...tempObject
        });
  
        dataToExport.push({
          combined_line_no: masterLineNo, 
         ...tempObject
  
        });

      }
    }
     let worksheet = xlsx.utils.json_to_sheet(sheetData!);
     let sheetObject = {
       worksheet: worksheet,
       name: doc.documentFileName,
     };
     allWorksheets.push(sheetObject);
    //  xlsx.utils.book_append_sheet(workbook, worksheet, `${doc.documentFileName}`);
  }
  // end doc loop
  let masterSheet = null;
  masterSheet = xlsx.utils.json_to_sheet(dataToExport);
  xlsx.utils.book_append_sheet(workbook, masterSheet, 'Combined');
  for (const sheet of allWorksheets) {
    xlsx.utils.book_append_sheet(
      workbook,
      sheet.worksheet,
      `${sheet.name.substring(0,25)}`
    );
  }
  const blob = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
  workbook = xlsx.utils.book_new();
  const url = window.URL.createObjectURL(
    new Blob([blob], { type: 'application/octet-stream' })
  );
  const a = document.createElement('a');
  a.href = url;
  a.download = `reportMultiDoc.xlsx - ${new Date()}`;
  a.click();
  window.URL.revokeObjectURL(url);
  return;
};